<div
  class="w-full p-8 bg-zinc-100 appel-a-candidatures creation flex-col justify-start items-start gap-2.5 inline-flex"
>
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div
    class="self-stretch h-full flex-col justify-start items-start gap-6 flex"
  >
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div
        class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
      >
        <div
          class="self-stretch text-gray-900 text-4xl font-semibold leading-[38px] mb-5"
        >{{ isEditMode ? 'Modifier l\'appel à candidatures parcours' : 'Appel à candidatures parcours' }}
          
        </div>
        <div
          class="self-stretch text-slate-600 text-base font-interRegular leading-normal mb-5"
        >
          Formulaire de création d'appel à candidatures
        </div>
      </div>
      <form [formGroup]="form" class="w-full">
        <!-- Champs pour les informations de l'application -->
        <div class="bg-white rounded-lg shadow dark:bg-gray-700">
          <fieldset class="cst-fieldset pr-db-w1 gap-4 p-6">
            <legend class="font-semibold text-xl pt-6">
              Informations de l'appel
            </legend>
            <div class="cst-line mb-6">
              <label for="applicationName" class="block text-md mb-2">
                Titre
              </label>
              <input
                class="w-full rounded-lg shadow border border-gray-300 cst-transition border rounded py-1 px-1"
                id="applicationName"
                type="text"
                formControlName="applicationName"
              />
            </div>
            <div class="cst-line mb-6">
              <label for="applicationInformations" class="block text-md mb-2">
                Donnez les détails de l'appel
              </label>
              <textarea
                class="w-full rounded-lg shadow border border-gray-300 cst-transition border rounded py-1 px-1"
                id="applicationInformations"
                formControlName="applicationInformations"
              ></textarea>
            </div>
            <div class="p-fluid p-formgrid grid" style="display: flex">
              <div
                class="cst-line mb-6 field col-12 mb-0 md:mb-4 md:col-6 pb-0 md:pr-0 pr-4"
              >
                <label for="openDate" class="block text-md mb-2">
                  Date d'ouverture des soumissions
                </label>
                <input
                  class="w-full rounded-lg shadow border border-gray-300 cst-transition border rounded py-1 px-1"
                  id="openDate"
                  type="date"
                  formControlName="openDate"
                  [attr.disabled]="isEditMode ? true : null"
                />
              </div>
              <div
                class="cst-line mb-6 field col-12 mb-0 md:mb-4 md:col-6 pb-0"
              >
                <label for="closeDate" class="block text-md mb-2">
                  Date de fermeture des soumissions
                </label>
                <input
                  class="w-full rounded-lg shadow border border-gray-300 cst-transition border rounded py-1 px-1"
                  id="closeDate"
                  type="date"
                  formControlName="closeDate"
                />
              </div>
            </div>
          </fieldset>
        </div>
        <!-- Critères d'éligibilité -->
        <div class="bg-white rounded-lg shadow dark:bg-gray-700">
          <fieldset class="cst-fieldset pr-db-w1 gap-4 p-6">
            <legend class="font-semibold text-xl pt-6">
              Familles de métiers
            </legend>
            <div class="cst-line mb-6">
              <button
                (click)="addEligibilityCriteria()"
                class="bg-blue-500 hover:bg-green-700 cst-transition text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                type="button"
              >
                Ajouter une famille
              </button>
            </div>
            <div formArrayName="familyMetierDTOList">
              <table valign="top" class="w-full text-left rtl:text-right">
                <thead class="">
                  <tr>
                    <th class="grid-cols-9">
                      <span class="text-md mb-2 font-normal">Famille</span>
                    </th>
                    <th class="grid-cols-9">
                      <span class="text-md mb-2 font-normal ml-2"
                        >Prérequis</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody valign="top">
                  <tr
                    valign="top"
                    *ngFor="
                      let familyMetierList of getEligibilityCriteriaControls();
                      let i = index
                    "
                    class=""
                  >
                    <td class="px-1 py-1 prerequis-td">
                      <!-- <input class="w-full mb-2 text-black-700 border rounded py-1 px-1 " type="text"  [formControl]="familyMetierList.get('name')"> -->
                      <select
                        class="appearance-none block w-full rounded-lg shadow border border-gray-300 cst-transition py-1 px-1 leading-tight focus:outline-none focus:bg-white"
                        [formControl]="familyMetierList.get('name')"
                      >
                        <option value="" disabled>Choisir une famille</option>
                        <option
                          *ngFor="let f of famillesMetiers"
                          [value]="f.name"
                        >
                          {{ f.name }}
                        </option>
                      </select>
                      <div
                        *ngIf="getShortName(i)"
                        class="mt-1 text-sm text-blue-500 italic"
                      >
                        Code : {{ getShortName(i) }}
                      </div>
                      <br />
                      <span class="action-supp-famille">
                        <button
                          (click)="removeEligibilityCriteria(i)"
                          class="py-2 px-6 cst-before cst-after cst-transition bg-red text-white font-bold py-1 px-1 rounded focus:outline-none focus:shadow-outline"
                          type="button"
                        >
                          Effacer la famille
                        </button>
                      </span>
                    </td>
                    <td class="px-1 py-1 prerequis-td">
                      <table
                        valign="top"
                        class="w-full text-sm text-left text-black-500 dark:text-black-400"
                      >
                        <tr
                          valign="top"
                          *ngFor="
                            let rule of familyMetierList.get('prerequisite')
                              .controls;
                            let j = index
                          "
                        >
                          <td class="px-1 prerequis_input">
                            <select
                              class="appearance-none block w-full rounded-lg shadow border border-gray-300 cst-transition border rounded py-1 px-1 leading-tight focus:outline-none focus:bg-white"
                              [formControl]="rule.get('name')"
                            >
                              <option
                                value="Connaissance de l’outil informatique"
                              >
                                Connaissance de l’outil informatique
                              </option>
                              <option value="Aptitudes en mathématiques">
                                Aptitudes en mathématiques
                              </option>
                              <option
                                value="Connaissance de la programmation informatique"
                              >
                                Connaissance de la programmation informatique
                              </option>
                              <option value="Connaissance de l’algorithmique">
                                Connaissance de l’algorithmique
                              </option>
                              <option value="Compétences en réseaux">
                                Compétences en réseaux
                              </option>
                              <option value="Capacités communicationnelles">
                                Capacités communicationnelles
                              </option>
                              <option
                                value="Intérêt pour le commerce et les ventes"
                              >
                                Intérêt pour le commerce et les ventes
                              </option>
                              <option value="Intérêt pour l'entrepreneuriat">
                                Intérêt pour l'entrepreneuriat
                              </option>
                              <option value="Aptitudes artistiques">
                                Aptitudes artistiques
                              </option>
                              <option value="Capacités rédactionnelles">
                                Capacités rédactionnelles
                              </option>
                              <option value="Culture générale">
                                Culture générale
                              </option>
                            </select>
                          </td>
                          <td class="px-1 niveaux-actions">
                            <button
                              #realBtn
                              alt="Ajouter un niveau"
                              title="Ajouter un niveau"
                              (click)="addRule(i)"
                              class="ajouter-niveau cst-before cst-after cst-transition bg-blue-500 hover:bg-green-700 text-white font-bold py-1 px-1 rounded focus:outline-none focus:shadow-outline"
                              type="button"
                            >
                              Ajouter un niveau
                            </button>
                            <button
                              alt="Supprimer un niveau"
                              title="Supprimer un niveau"
                              (click)="removeRule(i, j)"
                              class="ml-1 supprimer-niveau cst-before cst-after cst-transition bg-red hover:bg-red-700 text-white font-bold py-1 px-1 rounded focus:outline-none focus:shadow-outline"
                              type="button"
                            >
                              Supprimer
                            </button>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <!-- <td class="px-1 py-1 action-supp-famille">
                              <button  (click)="removeEligibilityCriteria(i)"class="cst-before cst-after cst-transition bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-1 rounded focus:outline-none focus:shadow-outline" type="button">
                                  Effacer la famille
                              </button>
                          </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>
        </div>
        <button
          class="cst-before cst-after cst-transition bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          (click)="openConfirmModal()"
        >
          {{ isEditMode ? 'Modifier l\'appel à candidature' : 'Créer l\'appel à candidature' }}
        </button>
      </form>
    </div>
  </div>
  <!-- Modale de confirmation -->
  <div
    *ngIf="showConfirmModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6"
    >
      <!-- Icône + Titre -->
      <div class="flex flex-col items-center gap-3 text-center">
        <div class="bg-green-100 rounded-full p-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-10 w-10 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 class="text-2xl font-semibold text-gray-900">
  {{ isEditMode ? 'Confirmer la modification' : 'Confirmer la création' }}
</h2>
<p class="text-slate-600 text-base">
  <ng-container *ngIf="!isEditMode">
    Vous êtes sur le point de créer un appel à candidatures.<br />
    Voulez-vous confirmer cette action ?
  </ng-container>
  <ng-container *ngIf="isEditMode">
    Vous êtes sur le point de modifier cet appel à candidatures.<br />
    Voulez-vous confirmer cette modification ?
  </ng-container>
</p>  
      </div>

      <!-- Récapitulatif -->
      <div
        class="bg-zinc-50 rounded-lg border border-gray-200 px-5 py-4 text-sm text-gray-700 flex flex-col gap-2"
      >
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Titre :</span>
          <span class="font-semibold">{{
            form.get("applicationName")?.value
          }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Ouverture :</span>
          <span>{{ form.get("openDate")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Fermeture :</span>
          <span>{{ form.get("closeDate")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Familles :</span>
          <span>{{ getEligibilityCriteriaControls().length }}</span>
        </div>
      </div>

      <!-- Boutons -->
      <div class="flex justify-end gap-3">
        <button
          (click)="cancelSubmit()"
          class="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 cst-transition focus:outline-none"
        >
          Annuler
        </button>
        <button
          (click)="confirmSubmit()"
          class="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-700 text-white font-bold cst-transition focus:outline-none focus:shadow-outline"
        >
          Confirmer
        </button>
      </div>
    </div>
  </div>
  <!-- Modale de succès -->
  <div
    *ngIf="showSuccessModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6"
    >
      <div class="flex flex-col items-center gap-3 text-center">
        <div class="bg-green-100 rounded-full p-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-10 w-10 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 class="text-2xl font-semibold text-gray-900">
          {{ isEditMode ? 'Modification réussie' : 'Création réussie' }}
        </h2>
        <p class="text-slate-600 text-base">
          {{
            isEditMode
              ? "L'appel à candidatures a bien été modifié."
              : "L'appel à candidatures a bien été créé."
          }}
        </p>
      </div>

      <div class="flex justify-end">
        <button
          (click)="closeSuccessModal()"
          class="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-700 text-white font-bold cst-transition focus:outline-none focus:shadow-outline"
        >
          OK
        </button>
      </div>
    </div>
  </div>

</div>
